module.exports = __webpack_public_path__ + "static/global-problems-9583c8ce8230dc4ee9946ab81d1cb712.jpg";